import { Box, Button, Modal, Text } from '@fozito/common-ui';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { FooterActions } from '../../components/styles';
import toast from 'utils/toast';
type Props = {
};
type Ref = {
  open: () => void;
};
export const useModalAlertEmptyRef = () => useRef<Ref>(null);
const ModalAlertEmpty = forwardRef<Ref, Props>(({ }, ref) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen: Ref['open'] = () => toast.warning('Please select products');
  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  const handleDone = () => {
    onClose();
  };
  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal title='Empty' open={open} onClose={onClose} width={700} onOk={handleDone}>
      <Box padding={24} textAlign='center'>
        <Text title_h6_20_regular>Please select products</Text>
      </Box>
      <FooterActions>
        <Button style={{ flex: 1 }} onClick={handleCancel} type_cancel><span>OK</span></Button>
      </FooterActions>
    </Modal>
  );
});
ModalAlertEmpty.displayName = 'ModalAlertEmpty';
export default ModalAlertEmpty;